import { RENTALS_CODE } from 'config/rentals'

export const state = () => ({
  rentalsSent: 0,
  totalRentals: 0,
  resultsFromRest: [],
  ga4: [],
  companies: {},
  companiesByStoreId: {},
  filteredResults: [],
  sortOptionSelected: 'recommended',
  userManualSortChoice: false,
  hasPromotions: false,
  enabledFilters: [],
  itinerary: null,
  endpointsData: null,
  initialSort: [],
  nearbyPlaces: null,
  urlParam: null,
  rentalCompanies: [],
  hasFilterInteraction: false,
  searchSessionId: null,
  trackingEnabled: false,
  multistoreLoadingPages: false,
  isMultiStore: false,
  isDistanceSortEnabled: false
})

export const actions = {
  ENDPOINTS_DATA: ({ commit }, data) => {
    commit('ENDPOINTS_DATA', data)
  },
  INCREMENT_REQUEST_RESPONSE: ({ commit }) => {
    commit('INCREMENT_REQUEST_RESPONSE')
  },
  INCREMENT_RESULTS: ({ commit }, data) => {
    commit('INCREMENT_RESULTS', data)
  },
  INCREMENT_COMPANIES: ({ commit }, data) => {
    commit('INCREMENT_COMPANIES', data)
    commit('INCREMENT_COMPANIES_BY_STORE_ID', data)
  },
  SET_ALL_RESULTS: ({ commit }, resultsFromRest) => {
    commit('SET_ALL_RESULTS', resultsFromRest)
  },
  SET_FILTERED_RESULTS: ({ commit }, filteredResults) => {
    commit('SET_FILTERED_RESULTS', filteredResults)
  },
  SET_SORT_OPTION_SELECTED: ({ commit }, sortOptionSelected) => {
    commit('SET_SORT_OPTION_SELECTED', sortOptionSelected)
  },
  SET_SORT_OPTION_SELECTED_FORCED: ({ commit }, sortOptionSelected) => {
    commit('SET_SORT_OPTION_SELECTED', sortOptionSelected)
  },
  SET_USER_MANUAL_SORT_CHOICE: ({ commit }, userManualChoice) => {
    commit('SET_USER_MANUAL_SORT_CHOICE', userManualChoice)
  },
  RESET_USER_MANUAL_SORT_CHOICE: ({ commit }) => {
    commit('SET_USER_MANUAL_SORT_CHOICE', false)
  },
  SET_HAS_PROMOTION: ({ commit }, hasPromotions) => {
    commit('SET_HAS_PROMOTION', hasPromotions)
  },
  SET_ENABLED_FILTERS: ({ commit }, enabledFilters) => {
    commit('SET_ENABLED_FILTERS', enabledFilters)
  },
  CLEAR: ({ commit }) => {
    commit('CLEAR')
  },
  SET_INITIAL_SORT: ({ commit }, data) => {
    commit('SET_INITIAL_SORT', data)
  },
  SET_URL_PARAM: ({ commit }, data) => {
    commit('SET_URLPARAM', data)
  },
  TOTAL_OF_RENTALS: ({ commit }, total) => {
    commit('TOTAL_OF_RENTALS', total)
  },
  SET_RENTAL_SENT: ({ commit }, total) => {
    commit('SET_RENTAL_SENT', total)
  },
  SET_RENTAL_COMPANIES_MAP: ({ commit }, data) => {
    commit('SET_RENTAL_COMPANIES_MAP', data)
  },
  async SET_ITINERARY ({ commit, dispatch }, data) {
    commit('SET_ITINERARY', data)
    if (!data) return

    const searchData = await dispatch('search/GET_SEARCH_DATA', undefined, { root: true })
    commit('search/SET_FORM_DATA', {
      ...(searchData || {}),
      PICKUP_PLACE: {
        Code: data.pickup.place.id,
        Name: data.pickup.place.name,
        timezone: { name: data.pickup.timeZone }
      },
      RETURN_PLACE: {
        Code: data.dropoff.place.id,
        Name: data.dropoff.place.name,
        timezone: { name: data.dropoff.timeZone }
      },
      SAME_LOCATION: data.pickup.place.id === data.dropoff.place.id
    }, { root: true })
  },
  SET_NEARBY: ({ commit }, data) => {
    commit('SET_NEARBY', data)
  },
  SET_FILTER_INTERACTION: ({ commit }, hasInteraction) => {
    commit('SET_FILTER_INTERACTION', hasInteraction)
  },
  SET_SEARCH_SESSION_ID: ({ commit }, sessionId) => {
    commit('SET_SEARCH_SESSION_ID', sessionId)
  },
  SET_TRACKING_ENABLED: ({ commit }, enabled) => {
    commit('SET_TRACKING_ENABLED', enabled)
  },
  RESET_FILTER_TRACKING: ({ commit }) => {
    commit('RESET_FILTER_TRACKING')
  },
  SET_MULTISTORE_LOADING_PAGES: ({ commit }, loading) => {
    commit('SET_MULTISTORE_LOADING_PAGES', loading)
  },
  SET_IS_DISTANCE_SORT_ENABLED: ({ commit }, data) => {
    commit('SET_IS_DISTANCE_SORT_ENABLED', data)
  },
  SET_IS_MULTISTORE: ({ commit }, data) => {
    commit('SET_IS_MULTISTORE', data)
  }
}

export const mutations = {
  ENDPOINTS_DATA: (state, data) => {
    state.endpointsData = data
  },
  TOTAL_OF_RENTALS: (state, quantity) => {
    state.totalRentals = parseInt(quantity, 10)
  },
  SET_RENTAL_SENT: (state, quantity) => {
    state.rentalsSent = parseInt(quantity, 10)
  },
  INCREMENT_REQUEST_RESPONSE: (state) => {
    state.rentalsSent += 1
  },
  INCREMENT_RESULTS: (state, data) => {
    const filteredData = data.filter(item =>
      !state.resultsFromRest.some(existingItem =>
        existingItem.vehicle.id === item.vehicle.id &&
        existingItem.rentalCompanyId === item.rentalCompanyId &&
        existingItem.rentalPickupStoreId === item.rentalPickupStoreId
      )
    )
    state.resultsFromRest = state.resultsFromRest.concat(filteredData)
    state.ga4 = state.ga4.concat(filteredData.map((r) => { return r.GA4.items }))
  },
  INCREMENT_COMPANIES: (state, data) => {
    state.companies[data.id] = data
  },
  INCREMENT_COMPANIES_BY_STORE_ID: (state, data) => {
    if (data.id !== RENTALS_CODE.OPAQUE || !(data.pickup.id in state.companiesByStoreId)) {
      state.companiesByStoreId[data.pickup.id] = data
    }
  },
  SET_ALL_RESULTS: (state, resultsFromRest) => {
    state.resultsFromRest = resultsFromRest
    state.ga4 = resultsFromRest.map((r) => { return r.GA4.items })
  },
  SET_FILTERED_RESULTS: (state, filteredResults) => {
    state.filteredResults = filteredResults
  },
  SET_SORT_OPTION_SELECTED: (state, sortOptionSelected) => {
    state.sortOptionSelected = sortOptionSelected
  },
  SET_USER_MANUAL_SORT_CHOICE: (state, userManualChoice) => {
    state.userManualSortChoice = userManualChoice
  },
  SET_HAS_PROMOTION: (state, hasPromotions) => {
    state.hasPromotions = hasPromotions
  },
  SET_ENABLED_FILTERS: (state, enabledFilters) => {
    state.enabledFilters = enabledFilters
  },
  SET_ITINERARY: (state, itinerary) => {
    state.itinerary = itinerary
  },
  SET_NEARBY: (state, nearbyPlaces) => {
    state.nearbyPlaces = nearbyPlaces
  },
  SET_URLPARAM: (state, urlParam) => {
    state.urlParam = urlParam
  },
  SET_FILTER_INTERACTION: (state, hasInteraction) => {
    state.hasFilterInteraction = hasInteraction
  },
  SET_SEARCH_SESSION_ID: (state, sessionId) => {
    state.searchSessionId = sessionId
  },
  SET_TRACKING_ENABLED: (state, enabled) => {
    state.trackingEnabled = enabled
  },
  RESET_FILTER_TRACKING: (state) => {
    state.hasFilterInteraction = false
    state.searchSessionId = null
    state.trackingEnabled = false
  },
  CLEAR: (state) => {
    state.rentalsSent = 0
    state.totalRentals = 0
    state.resultsFromRest = []
    state.ga4 = []
    state.companies = {}
    state.companiesByStoreId = {}
    state.filteredResults = []
    state.sortOptionSelected = 'recommended'
    state.userManualSortChoice = false
    state.hasPromotions = false
    state.enabledFilters = []
    state.itinerary = null
    state.endpointsData = null
    state.initialSort = []
    state.nearbyPlaces = null
    state.urlParam = null
    state.rentalCompanies = []
    state.hasFilterInteraction = false
    state.searchSessionId = null
    state.trackingEnabled = false
    state.multistoreLoadingPages = false
  },
  SET_INITIAL_SORT: (state, data) => {
    state.initialSort = data
  },
  SET_RENTAL_COMPANIES_MAP: (state, data) => {
    state.rentalCompanies = data
  },
  SET_MULTISTORE_LOADING_PAGES: (state, loading) => {
    state.multistoreLoadingPages = loading
  },
  SET_IS_DISTANCE_SORT_ENABLED: (state, data) => {
    state.isDistanceSortEnabled = data
  },
  SET_IS_MULTISTORE: (state, data) => {
    state.isMultiStore = data
  }
}

export const getters = {
  /**
   * @desc returns if all requests are send
   * @return {Boolean}
   */
  isAllRequestsSent: state => !state.multistoreLoadingPages && state.rentalsSent === state.totalRentals,

  /**
   * @desc returns length os companies
   * @returns {Number}
   */
  getTotalCompanies: state => state.totalRentals,

  /**
   * @desc returns number of rentals sent
   * @return {Number}
   */
  quantityRentalsSent: state => state.rentalsSent,

  /**
   * @desc all response from rest
   * @returns {Array}
   */
  getResults: state => state.resultsFromRest,

  getGa4: state => state.ga4,

  /**
   * @desc returns all companies
   * @returns {Object}
   */
  getCompanies: state => state.companies,

  /**
   * @desc returns all companies stores
   * @returns {Object}
   */
  getCompaniesByStoreId: state => state.companiesByStoreId,

  /**
   * @desc returns a company
   * @returns {Object}
   */
  getCompany: state => code => state.companies[code] || null,

  /**
   * @desc returns a store
   * @returns {Object}
   */
  getCompanyByStoreId: state => code => state.companiesByStoreId[code] || null,

  /**
  * @desc return filteredResults
  * @returns {String|null}
  */
  getFilteredResults: state => state.filteredResults,

  /**
  * @desc return sort method is active
  * @returns {String|null}
  */
  getSortOptionSelected: state => state.sortOptionSelected,

  /**
  * @desc return if user manually chose a sort option in variant
  * @returns {Boolean}
  */
  getUserManualSortChoice: state => state.userManualSortChoice,

  /**
  * @desc return if has promotion
  * @returns {String|null}
  */
  getHasPromotion: state => state.hasPromotions,

  /**
  * @desc return if has promotion
  * @returns {String|null}
  */
  getEnabledFilters: state => state.enabledFilters.filter(v => v !== undefined),

  /**
   * @desc returns an itinerary
   * @returns {Object}
   */
  getItinerary: state => state.itinerary,

  /**
   * @desc returns neabyPlaces
   * @returns {Object}
   */
  getNearbyPlaces: state => state.nearbyPlaces,

  /**
   * @desc returns urlParam
   * @returns {String}
   */
  getUrlParam: state => state.urlParam,

  /**
   * @desc returns if is a domestic pickup
   * @returns {Boolean}
   */
  isDomesticItinerary: state => state.itinerary !== null && state.itinerary.pickup.country.id === 1,

  /**
   * @desc returns data from endpoints request
   * @returns {Object}
   */
  getEndpointsData: state => state.endpointsData,

  /**
   * @desc returns initial sort data
   * @returns {Object}
   */
  getInitialSort: state => state.initialSort,

  /**
   * @desc returns rental Companies to Map
   * @returns {Object}
   */
  getRentalCompanies: state => state.rentalCompanies,

  /**
   * @desc returns if user had filter interaction in current session
   * @returns {Boolean}
   */
  getFilterInteraction: state => state.hasFilterInteraction,

  /**
   * @desc returns current search session ID
   * @returns {String}
   */
  getSearchSessionId: state => state.searchSessionId,

  /**
   * @desc returns if tracking is enabled for current session
   * @returns {Boolean}
   */
  getTrackingEnabled: state => state.trackingEnabled,

  /**
   * @desc returns if multistore is still searching more locations
   * @returns {Boolean}
   */
  getMultistoreLoadingPages: state => state.multistoreLoadingPages,

  /**
   * @desc returns if feature flag order_per_distance_pwa is enabled
   * @returns {Boolean}
   */
  isDistanceSortEnabled: state => state.isDistanceSortEnabled,

  /**
   * @desc returns if results came from multistore search
   * @returns {Boolean}
   */
  isMultiStore: state => state.isMultiStore
}
